// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_OO3","cls2":"AuthorHeader-cls2_6y7 AuthorHeader-cls1_OO3"};